import { isLocal, ENV } from 'CONFIG/config';
import { browser } from 'UTILS/browser';
import { locationReplace } from 'UTILS/utils';
import { envConf } from 'ENV';

const PROJECTREG = /(hydrogen|yoyo)/;
const INPC = browser.isHydrogenPC;
const INAPP = browser.isHydrogen || browser.isYoyo;
const INCLIENT = INPC || INAPP;

// 解决氧气马甲包自动重定向到对应马甲包地址
function inTransit() {
  // 本地运行不需要执行
  if (isLocal) return;

  const href = location.href;
  let url = '';
  if (INAPP && !browser.isHydrogen) {
    const isMatch = navigator.userAgent.match(PROJECTREG);
    // 不匹配中断
    if (isMatch === null) return false;

    // 匹配自动重定向
    const product = isMatch[0];
    const reg = /\/hydrogen\//g;
    if (reg.test(reg)) {
      url = href.replace(reg, `/${product}/`);
      locationReplace(url);
      return;
    }
  }

  // 充值页需重定向
  if (['prod', 'gray'].indexOf(ENV) > -1 && /\/recharge\//g.test(href)) {
    const origin = location.origin;
    const REDIRECT = envConf.REDIRECT;
    if (REDIRECT && REDIRECT !== origin) {
      url = href.replace(/(https?:\/\/[^\/]+)\//i, REDIRECT);
    }
    location.replace(url);
  }
}

export { INAPP, INCLIENT, INPC, inTransit };
